/** Mensagem genérica para erros 5xx — não expor detalhes técnicos ao utilizador. */
export const TECHNICAL_TEAM_ERROR_MESSAGE =
  'Ocorreu um problema e a nossa equipa técnica irá analisá-lo o mais rápido possível.'

export function isServerErrorStatus(status?: number): boolean {
  return status != null && status >= 500
}
